function updateShopifyCart(items = [], properties = {}, form) {
  // console.log("items", items, "properties", properties);
  const baseUrl = "/cart";

  // Helper function to add items to the cart with line item properties
  function addToCart(items, properties, form) {
    // Filter and format properties that start with "properties"
    const filteredProperties = Object.keys(properties)
      .filter(key => key.startsWith('properties['))
      .reduce((obj, key) => {
        const newKey = key.replace('properties[', '').replace(']', '');
        obj[newKey] = properties[key];
        return obj;
      }, {});

    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
      bubbles: true,
      detail: {
        sections: sectionsToBundle
      }
    }));

     const quantity = properties.quantity || 1; 
    
    const payload = items.map((item) => ({
      id: item.id,
      quantity: quantity,
      properties: filteredProperties, // Add filtered properties to each item
    }));

    // console.log("payload",payload);


    fetch(`${baseUrl}/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: payload,sections: sectionsToBundle.join(","), sections_url: `${Shopify.routes.root}variants/${items[0].id}` }),
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log("Success:", data);
        // Open Shopify mini cart if available
         async function updateCartAndDispatchEvents(data) {
              const response = await fetch(`${Shopify.routes.root}cart.js`);
              const cartContent = await response.json();
              cartContent.sections = data.sections;
            
              const items = data.hasOwnProperty("items") ? data.items : [data];
              form.dispatchEvent(new CustomEvent("variant:add", {
                bubbles: true,
                detail: { items, cart: cartContent }
              }));
            
              document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                  baseEvent: "variant:add",
                  cart: cartContent
                }
              }));
            }
         updateCartAndDispatchEvents(data)
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  // Call addToCart with items and properties
  addToCart(items, properties, form);
}

// Usage example for adding items
// updateShopifyCart([{id: "variantId1", quantity: 1}, {id: "variantId2", quantity: 2}], {
//   "form_type": "product",
//   "id": "40771169943630",
//   "product-id": "6998201925710",
//   "properties[Fillet Options-10]": "Salt the Fish",
//   "properties[Fillet Options-3]": "Next To Tail",
//   "quantity": "1",
//   "section-id": "template--15623932739662__main",
//   "utf8": "✓"
// });

















/*
function updateShopifyCart(items = [], properties = {}) {
  console.log("items", items, "properties", properties);
  const baseUrl = "/cart";

  // Helper function to add items to the cart with line item properties
  function addToCart(items, properties) {
    // Filter and format properties that start with "properties"
    const filteredProperties = Object.keys(properties)
      .filter(key => key.startsWith('properties['))
      .reduce((obj, key) => {
        const newKey = key.replace('properties[', '').replace(']', '');
        obj[newKey] = properties[key];
        return obj;
      }, {});

    const payload = items.map((item) => ({
      id: item.id,
      quantity: item.quantity,
      properties: filteredProperties, // Add filtered properties to each item
      
    }));


    fetch(`${baseUrl}/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: payload }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Success:", data);
        // Open Shopify mini cart if available
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  // Call addToCart with items and properties
  addToCart(items, properties);
}
*/

// Usage example for adding items
// updateShopifyCart([{id: "variantId1", quantity: 1}, {id: "variantId2", quantity: 2}], {
//   "form_type": "product",
//   "id": "40771169943630",
//   "product-id": "6998201925710",
//   "properties[Fillet Options-10]": "Salt the Fish",
//   "properties[Fillet Options-3]": "Next To Tail",
//   "quantity": "1",
//   "section-id": "template--15623932739662__main",
//   "utf8": "✓"
// });


















async function addToCart2(form, data, variantId, currentProductId) {
            ///////////////////////////////////////////////////////////////
            let sectionsToBundle = ["variant-added"];
            document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
               bubbles: true,
               detail: {
                  sections: sectionsToBundle
               }
            }));
      
            const formData = new FormData(form);
            let sectionsPro = sectionsToBundle.join(",");
            formData.set("sections", sectionsPro);
      
            let sectionsUrlPro = `${Shopify.routes.root}variants/${form.id.value}`;
            formData.set("sections_url", sectionsUrlPro);
      
            const object = {};
            formData.forEach((value, key) => {
               object[key] = object.hasOwnProperty(key) ? [].concat(object[key], value) : value;
            });
            object["product-id"] = currentProductId;
            object["id"] = variantId;
      
            const convertProperties = (obj) => {
               const newObj = {
                  ...obj,
                  properties: {}
               };
               Object.keys(obj).forEach(key => {
                  if (key.startsWith("properties[")) {
                     const propName = key.match(/properties\[(.*?)\]/)[1];
                     newObj.properties[propName] = obj[key];
                     delete newObj[key];
                  }
               });
               return newObj;
            };
            const convertedObject = convertProperties(object);
      
            try {
               const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
                  body: JSON.stringify(convertedObject),
                  method: "POST",
                  headers: {
                     "Content-Type": "application/json",
                     "X-Requested-With": "XMLHttpRequest"
                  }
               });
               const responseJson = await response.json();
               const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();      
               afterAddtoCart(form);
      
               if (response.ok) {
                  if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
                     window.location.href = `${Shopify.routes.root}cart`;
                  } 
                  else {
                     if (responseJson["sections"] == null) {
                        // console.log("SECTIONS NULL");
                        // console.log(cartContent);
      
                        const dataX = await cartSlight(sectionsPro, sectionsUrlPro, form);
                        // console.log('Data from cartSlight:', dataX);
      
                        responseJson["sections"] = await fetch(`/?sections=${sectionsPro}&sections_url=${sectionsUrlPro}`)
                           .then(response => response.json())
                           .catch(error => console.error('Error:', error));
                     }
                     cartContent["sections"] = responseJson["sections"];
                     form.dispatchEvent(new CustomEvent("variant:add", {
                        bubbles: true,
                        detail: {
                           items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
                           cart: cartContent
                        }
                     }));
                     document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                        bubbles: true,
                        detail: {
                           baseEvent: "variant:add",
                           cart: cartContent
                        }
                     }));
                     setTimeout(() => {
                        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                           bubbles: true,
                           detail: {
                              baseEvent: "variant:add",
                              cart: cartContent
                           }
                        }));
                     }, "5000")
                  }
               } 
               else {
                  form.dispatchEvent(new CustomEvent("cart:error", {
                     bubbles: true,
                     detail: {
                        error: responseJson["description"]
                     }
                  }));
               }
            } 
            catch (error) {
               console.error('Error:', error);
            }
            ///////////////////////////////////////////////////////////////
         }









